import * as React from 'react';
import { Sticky, Tag, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, NonRxProductCTA, ProductDetailTitleView, ProductDetailDescriptionView, ProductDetailDisclaimerView, ProductDetailPrice, ProductDiscountLabel, Discount, ProductDetailUspsView } from '@grandvisionhq/fun-products';
import { useReviewsContext, Actions, ReviewSnippet } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { getVariants } from '../../helpers.js';
import ProductDetailSpecification from '../../ProductDetailSpecification/ProductDetailSpecification.js';
import { useProductViewHistory } from '../../utils/use-product-view-history.js';
import { VariantPickerContainer } from '../Components/VariantPicker/VariantPickerContainer.js';

const Accessories = ({ activeSku , activeVariant , addToCartRef , brandLink , currency , dispatch , formatProductUrl , handleConversionEvent , isMobile , isSmallScreen , isOrderable , labels , locale , onCTAClick , product , productImageGallery , productTypeUsps , specificationConfiguration , stickyTop , stockCount , showStickyButton , variant , variants , disclaimer , storesRoute  })=>{
    const { accessoryColor , brand , channelAvailability , description , discounted , discountText , excludedFromCheckout , header , modelName , price , productType , sku , tag , usps ,  } = variant;
    const { Slots  } = useProductDetailSlots();
    const { isProductLabelEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    const reviews = useReviewsContext();
    // Add SKU to viewed product history
    React.useEffect(()=>{
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(sku);
    }, [
        variants.length,
        sku
    ]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews.enabled
    ]);
    const CTAButton = /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            variantUrl: formatProductUrl({
                productType,
                sku: activeSku || '',
                slug: product.slug
            }),
            onSuccess: onCTAClick
        }
    });
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: sku,
        variantId: activeSku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, productImageGallery), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: header,
        description: description,
        usps: usps
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration,
        variant: activeVariant
    })), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }, /*#__PURE__*/ React.createElement(ProductDetailDisclaimerView, {
        disclaimer: disclaimer
    })), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside",
        "data-t": "product-detail-aside",
        "aria-label": `${brand} ${modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isMobile
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    })), !isProductLabelEnabled && tag && tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(Tag, {
        iconKey: tag.key,
        label: tag.value
    })), price && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-prices",
        role: "group",
        "aria-label": labels.priceInformation
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: discountText
    }), !isProductLabelEnabled && discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: discountText,
        discount: discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null, !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: sku,
        variantId: activeSku
    }), /*#__PURE__*/ React.createElement(VariantPickerContainer, {
        variantItems: getVariants(variants, getLocalizedValue(product.slug, locale), productType, locale),
        activeVariantSku: sku,
        activeVariantLabel: accessoryColor,
        enableStockIndicator: !excludedFromCheckout,
        stockCount: stockCount,
        isAllowBackOrder: isOrderable,
        formatProductUrl: formatProductUrl,
        dispatch: dispatch,
        channelAvailability: variant.channelAvailability
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, CTAButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: CTAButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : price.originalPrice,
            currency: currency,
            centAmount: true,
            type: price.discountedPrice ? 'discount' : 'default'
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUspsView, {
        items: productTypeUsps
    })))));
};
var Accessories$1 = Accessories;

export { Accessories$1 as default };
//# sourceMappingURL=Accessories.js.map
